import { initializeApp } from 'firebase/app';
import { getFirestore, doc, setDoc, getDoc, collection, getDocs, deleteDoc } from 'firebase/firestore';
import { getAuth, signInWithEmailAndPassword, signOut } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAjNjZRSFaLqL-ltQFfKhoUhrGVHAdYdns",
  authDomain: "journal-missawoa.firebaseapp.com",
  projectId: "journal-missawoa",
  storageBucket: "journal-missawoa.firebasestorage.app",
  messagingSenderId: "199993397933",
  appId: "1:199993397933:web:5b43b07147d610d5f32c24"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

// ─── FONCTIONS DE BASE ─────────────────────────────────────────────────────

export async function saveClientData(clientId, data) {
  try {
    await setDoc(doc(db, 'journals', clientId), {
      ...data,
      updatedAt: new Date().toISOString()
    }, { merge: true });
    return true;
  } catch(e) {
    console.error('Erreur sauvegarde:', e);
    return false;
  }
}

export async function loadClientData(clientId) {
  try {
    const snap = await getDoc(doc(db, 'journals', clientId));
    return snap.exists() ? snap.data() : null;
  } catch(e) {
    console.error('Erreur chargement:', e);
    return null;
  }
}

export async function createClient(clientInfo) {
  try {
    await setDoc(doc(db, 'clients', clientInfo.id), {
      ...clientInfo,
      createdAt: new Date().toISOString()
    });
    return true;
  } catch(e) {
    console.error('Erreur création cliente:', e);
    return false;
  }
}

export async function loadAllClients() {
  try {
    const snap = await getDocs(collection(db, 'clients'));
    return snap.docs.map(d => d.data());
  } catch(e) {
    console.error('Erreur chargement clientes:', e);
    return [];
  }
}

export async function deleteClient(clientId) {
  try {
    await deleteDoc(doc(db, 'clients', clientId));
    await deleteDoc(doc(db, 'journals', clientId));
    return true;
  } catch(e) {
    return false;
  }
}

// ─── AUTHENTIFICATION COACH ───────────────────────────────────────────────

export async function loginCoach(email, password) {
  try {
    const result = await signInWithEmailAndPassword(auth, email, password);
    return { success: true, user: result.user };
  } catch(e) {
    const msg = e.code === 'auth/wrong-password' || e.code === 'auth/user-not-found'
      ? 'Email ou mot de passe incorrect.'
      : 'Erreur de connexion. Verifie ta connexion internet.';
    return { success: false, error: msg };
  }
}

export async function logoutCoach() {
  try { await signOut(auth); } catch(e) {}
}

export { db, auth };
